var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var BASE_PAGE_STATE_LIST_PROPERTIES = {
    loading: false,
    error: null,
    initialized: false,
    currentPage: 0,
    pageSize: 12,
    totalPages: 1,
};
export var BASE_PAGE_STORE_INITIAL_VALUES = __assign(__assign({}, BASE_PAGE_STATE_LIST_PROPERTIES), { total: 0, showControllers: false, searchString: '', isOpenModalFilter: false, isEndOfTheListReached: false });
